import React, { useContext, useState } from "react";
import "./singlePersonnel.scss";

import { Add, Close } from "@mui/icons-material";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import "react-phone-input-2/lib/style.css";
import imageAvatar from "../../../assets/images/studentpp.png";
import { PersonnelType, UserType } from "../../../types/GlobalType";
import { personnelContext } from "../../../context/AppContext";
import NewAccount from "./account/NewAccount.tsx";
import Delete from "../../../component/dialog/delete/Delete.tsx";
import { catchErrorApiCall } from "../../../_services/apiUtils.js";
import toast from "react-hot-toast";
import user_api from "../../../apiCaller/user.Caller.js";
import { accountService } from "../../../_services/accountServices.js";

interface Props {
  setOpen: React.Dispatch<React.SetStateAction<Boolean>>;
  accountExists: UserType | undefined;
  dispatchReload: () => void;
}

const SinglePersonnel = (props: Props) => {
  const navigate = useNavigate();

  let gg = useContext(personnelContext);
  // console.log(gg);

  const [openAddAccount, setOpenAddAccount] = useState<boolean>(false);
  const [openDeleteCompte, setopenDeleteCompte] =
    React.useState<Boolean>(false);

  const [loadingDeleteBtn, setLoadingDeleteBtn] =
    React.useState<boolean>(false);

  const handleNavidate1 = () => {
    navigate("");
  };
  const handleNavidate2 = () => {
    navigate("parcours-info");
  };
  const handleNavidate3 = () => {
    navigate("compte-info");
  };

  const location = useLocation();
  let currentRoute: string = location.pathname.split("/")[2];

  let isPersonnelPath: boolean =
    location.pathname.split("/")[1].toLowerCase() === "personnels";

  const personnelData: PersonnelType = useContext(personnelContext);

  let contextData = {
    context: props.accountExists,
    setOpen: props.setOpen,
    dispatchReload: props.dispatchReload,
    accountExists: props.accountExists,
  };

  const handleDeleteAccount = async (id: string | number | undefined) => {
    let token = accountService.getToken();

    if (!token) {
      toast.error("Votre session a expiré, veuillez vous reconnectez", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
          zIndex: 9999,
        },
      });

      accountService.logout();
      return navigate("/login", { replace: true });
    }
    try {
      await user_api.delete(id, token);
      props.dispatchReload();
      setLoadingDeleteBtn(false);
      setopenDeleteCompte(false);
      props.setOpen(false);

      toast.success("Suppression effectuée avec succès", {
        style: {
          zIndex: 9999,
        },
      });
    } catch (error) {
      // console.log(error);
      setLoadingDeleteBtn(false);

      if (error.code === "ERR_NETWORK") {
        setopenDeleteCompte(false);
        props.setOpen(false);

        return toast.error(
          "Vérifiez votre connexion internet, ensuite réessayez",
          {
            style: {
              backgroundColor: "#630f0f", // Custom background color
              color: "white", // Text color
              fontSize: "12px", // Font size
              zIndex: 99999,
            },
          },
        );
      }
      catchErrorApiCall(error);
    }
  };

  React.useEffect(() => {
    navigate("");
  }, []);

  return (
    <div className="ProfilPersonnel">
      <div className="dialog">
        <div className="headerUpdate">
          <div className="titleUpdate">
            <div className="left_">
              <span>Profile Personnel </span>
            </div>
            <div className="right_">
              <Close className="ico" onClick={() => props.setOpen(false)} />
            </div>
          </div>
        </div>

        <div className="body">
          <div className="avatar_info">
            <div className="img_container">
              <img src={imageAvatar} alt="" />
              <div className="names">
                <h3>{`${personnelData.nom?.toUpperCase()} ${personnelData.postnom?.toUpperCase()} ${personnelData.prenom?.toUpperCase()}`}</h3>
                <span>
                  {`${personnelData.fonction_designation?.toUpperCase()}`}
                </span>
              </div>
            </div>
            {/* <div className="btns">
              {personnelData.personnel_status ? (
                <button>Actif</button>
              ) : (
                <button>Non actif</button>
              )}
            </div> */}

            {!isPersonnelPath ? (
              !props.accountExists ? (
                <div className="btns" onClick={() => setOpenAddAccount(true)}>
                  <Add className="icos" />
                  <button>Créer un compte</button>
                </div>
              ) : (
                <div
                  className="btnDeactivate"
                  onClick={() => setopenDeleteCompte(true)}
                >
                  <span style={{ fontSize: "12px" }}>Supprimer ce compte </span>
                </div>
              )
            ) : null}
          </div>
          <div className="links">
            <span onClick={handleNavidate1}>
              Appercu
              <div
                className={currentRoute === undefined ? "underline1" : ""}
              ></div>
            </span>

            <span onClick={handleNavidate2}>
              Contact
              <div
                className={currentRoute === "parcours-info" ? "underline2" : ""}
              ></div>
            </span>
            {!!props.accountExists && (
              <span onClick={handleNavidate3}>
                Compte
                <div
                  className={currentRoute === "compte-info" ? "underline2" : ""}
                ></div>
              </span>
            )}
          </div>
          <Outlet
            context={contextData}
            // context={props.accountExists}
          />
        </div>
      </div>

      {openAddAccount && (
        <NewAccount
          setOpen={setOpenAddAccount}
          data={personnelData}
          setOpen2={props.setOpen}
          dispatchReload={props.dispatchReload}
        />
      )}

      {openDeleteCompte && (
        <Delete
          setOpen={setopenDeleteCompte}
          itemId={props.accountExists?.user_id}
          label={"Voulez-vous vraiment supprimer ce compte?"}
          handleDelete={handleDeleteAccount}
          loadingDeleteBtn={loadingDeleteBtn}
          setLoadingDeleteBtn={setLoadingDeleteBtn}
          // title="Supprimer"
        />
      )}
    </div>
  );
};

export default SinglePersonnel;
